import {
  FETCH_REVIEWS_REQUEST,
  FETCH_REVIEWS_SUCCESS,
  FETCH_REVIEWS_FAILURE,
  SET_REVIEWS_FILTER,
  TripReasonFilter,
} from './constants'
import { mapReviews } from './mappers'

interface FetchReviewsRequestAction {
  type: typeof FETCH_REVIEWS_REQUEST
  payload: {
    propertyId: number
    language: string
    page: number
    tripReason?: TripReasonFilter
  }
}

interface SetCurrentFilterAction {
  type: typeof SET_REVIEWS_FILTER
  payload: {
    filter?: TripReasonFilter
  }
}

interface FetchReviewsSuccessAction {
  type: typeof FETCH_REVIEWS_SUCCESS
  payload: ReturnType<typeof mapReviews>
}

interface FetchReviewsFailureAction {
  type: typeof FETCH_REVIEWS_FAILURE
  payload: {
    error: string
  }
}

export type ReviewsActions =
  | FetchReviewsRequestAction
  | FetchReviewsSuccessAction
  | FetchReviewsFailureAction
  | SetCurrentFilterAction

export const fetchReviewsRequestAction = (payload: FetchReviewsRequestAction['payload']) => ({
  type: FETCH_REVIEWS_REQUEST,
  payload,
})

export const setCurrentFilter = (payload: SetCurrentFilterAction['payload']) => ({
  type: SET_REVIEWS_FILTER,
  payload,
})

export const fetchReviewsSuccessAction = (payload: FetchReviewsSuccessAction['payload']) => ({
  type: FETCH_REVIEWS_SUCCESS,
  payload,
})

export const fetchReviewsFailureAction = (payload: FetchReviewsFailureAction['payload']) => ({
  type: FETCH_REVIEWS_FAILURE,
  payload,
})
